import React from "react";
import { Group, Text, Title } from "@mantine/core";

interface PageHeadingProps {
  title: string;
}

interface SubHeadingProps extends PageHeadingProps {
  size?: 1 | 2 | 3 | 4 | 5 | 6;
}

const PageHeading: React.FC<React.PropsWithChildren<PageHeadingProps>> = ({
  title,
  children,
}) => (
  <Group position="apart" align="start">
    <Text className="Heading">{title}</Text>
    <Group spacing="xl">{children}</Group>
  </Group>
);

const PageSubHeading: React.FC<SubHeadingProps> = ({ title, size }) => (
  <div className="settings-header">
    <Title order={size || 2} pb={8}>
      {title}
    </Title>
  </div>
);

export default PageHeading;
export { PageSubHeading };
